export interface ColorHsl {hue:number; saturation: number; lightness: number};
export interface ColorRgb {red:number; green: number; blue: number};

export const generateColors = (count: number): ColorHsl[] => {
  const hueStart = 0; // 赤系からスタート
  const hueSkipStart = 50; // 黄色は視認性が悪いのスキップ
  const hueSkipEnd = 80;
  const hueRange = 360 - (hueSkipEnd - hueSkipStart); // 黄色を除いた有効範囲
  return Array.from({ length: count }, (_, i) => {
    let hue = (hueStart + (i * hueRange / count)) % 360;
    // 黄色の範囲に入ったらスキップ（強制的に範囲外に調整）
    if (hue >= hueSkipStart && hue <= hueSkipEnd) {
      hue += (hueSkipEnd - hueSkipStart); // 黄色部分をスキップ
      hue %= 360; // 360°を超えた場合の処理
    }
    // const saturation = 70 + Math.random() * 20; // 70%〜90%の彩度
    // const lightness = 40 + Math.random() * 10; // 40%〜50%の明度
    const saturation = 90; // 90%の彩度
    const lightness = 40; // 40%の明度
    return {
      hue,
      saturation,
      lightness
    };
  });
};

export const hslToRgb = (h: number, s: number, l: number): ColorRgb => {
  // eslint-disable-next-line no-param-reassign
  s /= 100; l /= 100;
  const k = (n: number) => (n + h / 30) % 12;
  const a = s * Math.min(l, 1 - l);
  const f = (n: number) =>
    l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
  return {
    red: Math.round(f(0) * 255),
    green: Math.round(f(8) * 255),
    blue: Math.round(f(4) * 255)
  }
};
